import { gql, useLazyQuery } from "@apollo/client";
import { getErrors } from "../../utils";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { MetricTrendModel, PermitMetricQueryInput } from "./getPermitsCountByStatesMetric";

export interface PermitIssueTrendMetric_value {
  __typename: "MetricValueModel";
  value: number;
  previousValue: number | null;
  delta: number | null;
  deltaPercentage: number | null;
  trend: MetricTrendModel;
}

export interface PermitIssueTrendMetric_group {
  __typename: "MetricGroupModel";
  dimensionKey: string;
  dimensionValue: string;
  value: PermitIssueTrendMetric_value;
}

export interface PermitIssueTrendMetric {
  permitIssueTrendMetric: {
    __typename: "MetricIssueTrend";
    groups: PermitIssueTrendMetric_group[];
  };
}

export interface PermitIssueTrendMetricVariables {
  query: PermitMetricQueryInput;
}

export const GET_PERMIT_ISSUE_TREND_METRIC = gql`
  query PermitIssueTrendMetric($query: PermitMetricQueryInput!) {
    permitIssueTrendMetric(query: $query) {
      groups {
        dimensionKey
        dimensionValue
        value {
          value
          previousValue
          delta
          deltaPercentage
          trend {
            key
            name
          }
        }
      }
    }
  }
`;

export function useGetPermitIssueTrendMetric() {
  const [getPermitIssueTrendMetric, { loading, error, data }] = useLazyQuery<
    PermitIssueTrendMetric,
    PermitIssueTrendMetricVariables
  >(GET_PERMIT_ISSUE_TREND_METRIC, {
    errorPolicy: "all",
    fetchPolicy: "cache-and-network",
  });

  return {
    getPermitIssueTrendMetric,
    data,
    status: {
      loading,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncQueryStatus,
  };
}
